export const RECENTLY_VIEWED_PRODUCTS_STORAGE_KEY = 'recentlyViewedProducts';

const MAX_RECENT_PRODUCTS = 30;

export interface RecentlyViewedProduct {
  id: string;
  label: string;
  href: string;
  productLabel: string;
  date: string;
}

export interface RecentlyViewedProductInput {
  id?: string;
  label?: string;
  href?: string;
  productLabel?: string;
}

function isRecentlyViewedProduct(product: Partial<RecentlyViewedProduct>): product is RecentlyViewedProduct {
  return !!product?.id && !!product.label && !!product.href && !!product.productLabel && !!product.date;
}

export function getRecentlyViewedProducts(): Array<RecentlyViewedProduct> {
  const savedProducts = localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_STORAGE_KEY);

  if (!savedProducts) {
    return [];
  }

  try {
    const parsedProducts = JSON.parse(savedProducts);
    return Array.isArray(parsedProducts) ? parsedProducts.filter(isRecentlyViewedProduct) : [];
  } catch {
    return [];
  }
}

export function addRecentlyViewedProduct(product: RecentlyViewedProductInput, date = new Date().toISOString()) {
  const id = product.id?.trim();
  const label = product.label?.trim();
  const href = product.href?.trim();
  const productLabel = product.productLabel?.trim();

  if (!id || !label || !href || !productLabel) {
    return;
  }

  const productEntry: RecentlyViewedProduct = {
    id,
    label,
    href,
    productLabel,
    date,
  };
  const recentProducts = getRecentlyViewedProducts();
  const updatedProducts = [productEntry, ...recentProducts.filter((product) => product.id !== id)].slice(
    0,
    MAX_RECENT_PRODUCTS,
  );

  localStorage.setItem(RECENTLY_VIEWED_PRODUCTS_STORAGE_KEY, JSON.stringify(updatedProducts));
}
